var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank","rel":"noopener ugc","aria-label":_vm.account.type},on:{"click":_vm.click}},[_c(_vm.getSocialIconComponentName(_vm.account.type),{tag:"component",attrs:{"title":" "}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }